import React from "react";
import { Award, Check } from "lucide-react";
import Reveal from "./Reveal";
import { FOUNDER } from "../data/content";

export default function Legacy() {
  return (
    <section id="legacy" className="relative z-10 py-28 md:py-40" data-testid="legacy">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-sm font-500 tracking-[0.3em] uppercase text-[#D95A41] mb-6">In Memoriam · Founding Legacy</p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Monogram medallion — replace with a real photo of the founder when available */}
          <Reveal className="lg:col-span-4" y={60}>
            <div className="relative rounded-3xl border border-white/10 bg-gradient-to-b from-[#0B132B] to-[#050A14] p-6 text-center" data-testid="founder-medallion">
              <div className="overflow-hidden rounded-2xl border border-[#D95A41]/40">
                <img
                  src="/team/ilam-kamboj.jpg?v=2"
                  alt="Shri Ilam C. Kamboj, Founder"
                  className="w-full h-auto object-cover"
                />
              </div>
              <h3 className="mt-6 text-2xl font-700 text-[#F2EFE9]">{FOUNDER.name}</h3>
              <p className="mt-1 text-sm tracking-widest uppercase text-[#94A3B8]">{FOUNDER.honorific}</p>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <Reveal>
              <blockquote className="text-2xl md:text-4xl font-300 leading-[1.25] tracking-tight text-[#F2EFE9] border-l-2 border-[#D95A41] pl-6 md:pl-8 italic">
                “{FOUNDER.quote}”
              </blockquote>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="mt-10 space-y-5 text-lg text-[#94A3B8] leading-relaxed">
                <p>{FOUNDER.bio}</p>
                <p>{FOUNDER.bio2}</p>
                <p className="text-[#F2EFE9]">{FOUNDER.bio3}</p>
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
                {FOUNDER.achievements.map((a) => (
                  <div key={a} className="flex items-start gap-3 rounded-xl border border-white/10 bg-[#0B132B]/50 p-4">
                    <Check size={18} className="text-[#D95A41] mt-0.5 shrink-0" />
                    <span className="text-sm text-[#F2EFE9]/90 leading-snug">{a}</span>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-10 flex items-center gap-3 text-[#94A3B8]">
                <Award size={18} className="text-[#D95A41]" />
                <p className="text-sm">
                  Founded 2017 · Now relaunched in his memory by Shray Kamboj, carrying forward a legacy
                  of governance excellence.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
